import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { getPartners } from '../../util/api';
import { storableError } from '../../util/errors';

/**
 * The verified Zuprize Partners, each with its own withdrawal form address
 * (`angreskjemaUrl`, operator-only account metadata), from our own server
 * like the Butikker page.
 */
export const loadAngreskjemaPage = createAsyncThunk(
  'AngreskjemaPage/load',
  async ({ config }, { rejectWithValue }) => {
    try {
      const response = await getPartners(config?.marketplaceRootURL);
      return { partners: response?.partners || [] };
    } catch (e) {
      return rejectWithValue(storableError(e));
    }
  }
);

const angreskjemaPageSlice = createSlice({
  name: 'AngreskjemaPage',
  initialState: { partners: [], loadInProgress: false, loadError: null },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(loadAngreskjemaPage.pending, state => {
        state.loadInProgress = true;
        state.loadError = null;
      })
      .addCase(loadAngreskjemaPage.fulfilled, (state, action) => {
        state.loadInProgress = false;
        state.partners = action.payload.partners;
      })
      .addCase(loadAngreskjemaPage.rejected, (state, action) => {
        state.loadInProgress = false;
        state.loadError = action.payload;
      });
  },
});

export default angreskjemaPageSlice.reducer;

export const loadData = (params, search, config) => dispatch =>
  dispatch(loadAngreskjemaPage({ config }));
